import { createReducer } from '@reduxjs/toolkit';
import {
  storeEventTypesAction,
  storeObjectCharacteristicsAction,
  storeObjectTypesAction,
  storeOfferFeaturesAction,
} from './ListingOptionsActionCreators';
import { IdNameModel } from './ListingOptionsModels';

export interface ListingOptionsReducerState {
  eventTypes: IdNameModel[];
  objectTypes: IdNameModel[];
  objectCharacteristics: IdNameModel[];
  offerFeatures: IdNameModel[];
}

export const initialState: ListingOptionsReducerState = {
  eventTypes: [],
  objectTypes: [],
  objectCharacteristics: [],
  offerFeatures: [],
};

export const listingOptionsReducer = createReducer(initialState, (builder) => {
  builder.addCase(storeEventTypesAction, (state, action) => {
    state.eventTypes = action.payload.eventTypes;
  });
  builder.addCase(storeObjectTypesAction, (state, action) => {
    state.objectTypes = action.payload.objectTypes;
  });
  builder.addCase(storeObjectCharacteristicsAction, (state, action) => {
    state.objectCharacteristics = action.payload.objectCharacteristics;
  });
  builder.addCase(storeOfferFeaturesAction, (state, action) => {
    state.offerFeatures = action.payload.offerFeatures;
  });
});
